module.exports = __webpack_public_path__ + "img/notice.1135a074.png";